import React, { useState } from "react";
import "../css/comments.css";
import CommentReportForm from "./reportComment.js"
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function CommentCard({onclose, comment_id, content, image, video, date_created, number_likes, event_name, author, isSuperuser, author_picture, performCommentLike, fetchComments}) {
    
    let username = (sessionStorage.getItem("USER") === null ? null : JSON.parse(sessionStorage.getItem("USER"))['username']);
    let admin = (sessionStorage.getItem("USER") === null ? null : JSON.parse(sessionStorage.getItem("USER"))['admin']);

    const [reportId, setReportId] = useState(false);
    const [isReportVisible, setIsReportVisible] = useState(false);
    const {language} = useLanguage();

    console.log({author})

    const translations = {
      en: {
          deleteComment: "Are you sure you want to delete this comment?",
          scrollMore: "Scroll for more!",
          like: "Like",
          cancelReport: "Cancel Report",
          reportComment: "Report Comment",
          delete: "Delete",
          youNeedToSignInToPostAComment: "You need to sign in to post a comment.",
          pleaseEnterYourComment: "Please enter your comment",
          uploadAnImage: "Upload An Image",
          uploadAVideo: "Upload An Video",
          addComment: "Add Comment",

          
      },
      gd: {
        deleteComment: "A bheil thu cinnteach gu bheil thu airson an abairt seo a dhubhadh às?",
        scrollMore: "Scrolaig air adhart airson tuilleadh!",
        like: "Is toigh leam seo",
        CancelReport: "Cuir às don aithisg",
        reportComment: "Thoir cunntas air a' bheachd",
        delete: "Dùbh às",
        youNeedToSignInToPostAComment: "Feumaidh tu soidhneadh a-steach gus abairt a sgrìobhadh",
        pleaseEnterYourComment: "Cuir a-steach d' abairt",
        uploadAnImage: "Luchdaich suas ìomhaigh",
        uploadAVideo: "Luchdaich suas bhidio",
        addComment: "Sgrìobh beachd",
          
      },
  };

    function handleCommentLike(comment_id) {
        let username = JSON.parse(sessionStorage.getItem("USER"))['username']
        performCommentLike(comment_id, username);
        setTimeout(fetchComments, 500);
    }

    const handleReportComment = async (comment_id) => {
      setIsReportVisible(!isReportVisible);
      setReportId(comment_id);
    }

    const handleDeleteComment= async(comment_id) => 
    {
        if (window.confirm(translations[language].deleteComment)){
            console.log("deleted");

            try{
    
              const response = await fetch(
                `${BASE_URL}/api/delete_comment/`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
      
                  body: JSON.stringify({ 
                    comment_id: comment_id,
                  }),
                });
      
                const data = await response.json();
                console.log("Deleted comment: ", comment_id);
                fetchComments()
      
              } catch (error) {
                console.error('Error deleting comment:', error);
              }
        }   
    }

    return(

        <div className="comment-card">
            
            <div className="comment-header">
                <div>
                <img
                    id="comment-profile-picture"
                    src={ author_picture }
                    alt = "Profile Picture"
                    />
                <p id="comment-author"> {author} </p>
                </div>
                <p> Posted {new Date(date_created).toLocaleDateString("en-UK")}</p>
            </div>

            <p> {content}</p>

            <div className="comment-media">
                {JSON.stringify({image}["image"]) !== "null" && (
                <img className = "event-image" src = {image} alt = "comment image" />
                )}
                {JSON.stringify({video}["video"]) !== "null" &&  (
                    <video className = "comment-video" controls autoPlay src= {video} alt="comment vid" />
                )}
            </div>

            {JSON.stringify({image}["image"]) !== "null" && JSON.stringify({video}["video"]) !== "null" && (
                <small className="scroll-info">{translations[language].scrollMore}</small>
            )}
            
            {/* <p>Likes: {number_likes}</p> */}

            <div className="comment-button-container">
            {(username !== null) && (
              <button 
                  onClick={() => handleCommentLike(comment_id)} 
                  id="like-button"
              > 
                {translations[language].like} {number_likes}
              </button>
            )}

            {(username !== null) && ( 
            <button 
              onClick={() => handleReportComment(comment_id)} 
              id="like-button"
            > 
              {isReportVisible ? translations[language].cancelReport : translations[language].reportComment}
            </button>
            )}

            {(username === author || admin || isSuperuser) && (
                <button
                  onClick={() => handleDeleteComment(comment_id)}
                  id="delete-button"
                >
                  {translations[language].delete}
                </button>
            )}
            </div>

            {isReportVisible && (
                <CommentReportForm 
                  comment_id = {reportId}
                  onClose= {() => setIsReportVisible(false)}
                />
            )}

        </div>
    )
};

export default CommentCard;